// services/saleng.js
import axios from "./apiClient";
import { jwtDecode } from "jwt-decode";
import {SALENG_SHOP_API_PROD } from "./../config";

const SALENG_SHOP_API = SALENG_SHOP_API_PROD;

/* ---------------- Helpers: ดึงค่าจาก token ทุกครั้ง ---------------- */
const getAccessToken = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) return null;

  try {
    return JSON.parse(token);
  } catch {
    return token;
  }
};

const decodeToken = () => {
  const token = getAccessToken();
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

const getIds = () => {
  const decoded = decodeToken();
  return {
    accessToken: getAccessToken(),
    userId: decoded?.id ?? null,
    shopId: decoded?.shopId ?? null,
    branchId: localStorage.getItem("branchId"),
  };
};

export const getDailyPurchaseSummary = (startDate,endDate) => {
  const { branchId,shopId } = getIds();
  if (!branchId) return Promise.reject("Missing branchId (token?)");
  return axios.get(`${SALENG_SHOP_API}/report/daily-purchase-summary?start=${startDate}&end=${endDate}&branchId=${branchId}&shopId=${shopId}`, {
    headers: { "Content-Type": "application/json" },
  });
};
